


















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({})
export default class Permit extends Vue {
    @Getter('permitResources') permitResources!: any;
    @Prop({ default: 'inline-block', type: String }) display?: string;
    @Prop({ type: String }) className?: string;
    @Prop({ type: String, required: true }) resourceKey!: string;

    isValid() {
        const { btn } = this.permitResources;
        return !!btn[this.resourceKey];
    }

    handleTips() {
        this.$message.warning('您暂无此权限');
    }
}
